import { useEffect, useState } from "react";
const MOBILE_MAX_WIDTH = 750;
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_MAX_WIDTH);
    const [screenSize, setScreenSize] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize(width);
            setIsMobile(width <= MOBILE_MAX_WIDTH);
        };

        handleResize(); // Initial check
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return { isMobile, setIsMobile, screenSize };
};

export default useIsMobile;
